// source: messages/enums/source_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

goog.exportSymbol("proto.SourceType", null, global);
/**
 * @enum {number}
 */
proto.SourceType = {
  DEVICE_BULK_EDIT: 0,
  DEVICE_BULK_REGISTER: 1,
  GENERIC_TASK: 2,
};

goog.object.extend(exports, proto);
